import { useId, useState, useCallback } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { Tablist } from '@ui/kit';
import { BulbIcon } from '@ui/kit/icons';
import { SizeTransition } from '@utils/react';
import { wrapper, title, titleIcon, panel, cardList, cardListTransitionDurationMs } from './_resource.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ResourceCard } from './molecule.card/_card.js';

function Resources(props) {
  const baseId = `resources-${useId()}`;
  const [selectedGroup, setSelectedGroup] = useState(props.resourceGroups[0]);
  const handleTabClick = useCallback(tabId => {
    const selectedGroup = props.resourceGroups.find(group => group.id === tabId);
    if (!selectedGroup) {
      return;
    }
    setSelectedGroup(selectedGroup);
  }, [props.resourceGroups]);
  return /*#__PURE__*/jsxs("article", {
    className: wrapper,
    id: props.id,
    children: [/*#__PURE__*/jsxs("h2", {
      className: title,
      children: [props.context === "resource-dropdown" && /*#__PURE__*/jsx("i", {
        className: titleIcon,
        children: /*#__PURE__*/jsx(BulbIcon, {
          height: 30
        })
      }), " ", "Ressourcer"]
    }), props.resourceGroups.length > 1 && /*#__PURE__*/jsx(Tablist, {
      baseId: baseId,
      label: "V\xE6lg resourcegruppe",
      selectedTabId: selectedGroup?.id,
      tabs: props.resourceGroups,
      onTabClick: handleTabClick
    }), /*#__PURE__*/jsx("section", {
      className: panel,
      role: "tabpanel",
      id: `${baseId}-panel-${selectedGroup?.id}`,
      "aria-labelledby": `${baseId}-tab-${selectedGroup?.id}`,
      children: /*#__PURE__*/jsx(TransitionGroup, {
        component: null,
        children: /*#__PURE__*/jsx(SizeTransition, {
          axis: "vertical",
          swappable: true,
          timeout: cardListTransitionDurationMs,
          classNames: cardList,
          children: ref => /*#__PURE__*/jsx("ul", {
            ref: ref,
            className: cardList,
            children: selectedGroup?.children?.map(it => /*#__PURE__*/jsx("li", {
              children: /*#__PURE__*/jsx(ResourceCard, {
                context: props.context,
                resource: it,
                onLinkClick: props.onLinkClick
              })
            }, it.id))
          })
        }, `cardList-${selectedGroup?.id}`)
      })
    })]
  });
}

export { Resources };
//# sourceMappingURL=_resource.js.map
